import {Component} from '@angular/core';
import {RunningResultEnum} from '../../interfaces/RunningResultEnum';
import {Select, Store} from '@ngxs/store';
import {ProfileState} from '../../states/profile/profile.state';
import {Observable} from 'rxjs/internal/Observable';
import {IWholesaler} from '../../interfaces/wholesaler.interface';
import {CloseRunningWholesalerMessage} from '../../states/profile/profile.actions';
import {fadeInOut} from '../../animations/animations';

@Component({
  selector: 'app-wholesaler-result-message',
  templateUrl: './wholesaler-result-message.component.html',
  styleUrls: ['./wholesaler-result-message.component.scss'],
  animations: [fadeInOut],
})
export class WholesalerResultMessageComponent {

  RunningResultEnum = RunningResultEnum;

  @Select(ProfileState.runningWholesaler) runningWholesaler$: Observable<IWholesaler>;
  @Select(ProfileState.runningResult) runningResult$: Observable<RunningResultEnum>;

  constructor(
    private store: Store,
  ) {
  }

  closeRunningWholesalerDialog(): void {
    this.store.dispatch(new CloseRunningWholesalerMessage());
  }
}
